import { useMutation } from 'react-query';
import { useQuery } from 'react-query';

import { request } from 'utils';

export type GenerateQRCode = {
  id: string;
  expire_in: number;
  user_id: string;
  state: 'generated' | 'scanned' | 'confirmed';
  location?: string;
  create_at?: number;
  lp?: string;
};

const url = `/user/create_qrcode`;

export const useGenerateQRCode = () => {
  return useQuery(['generateQRCode'], () =>
    request.post<{ qrcode: GenerateQRCode }>(url).then(data => data.qrcode),
  );
};

export const useGetQRCodeStatus = (
  qrcode_id: string,
  status: 'generated' | 'scanned' | 'confirmed',
) => {
  return useQuery(
    ['qrcodeStatus'],
    async () => {
      if (!qrcode_id) {
        return;
      }
      return request
        .get<{ qrcode: GenerateQRCode }>('/user/qrcode', { qrcode_id })
        .then(data => data.qrcode);
    },
    {
      refetchInterval: 3000,
      staleTime: 3000,
      cacheTime: 3000,
      enabled: status === 'generated',
    },
  );
};

export const useConfirmQRCode = () => {
  return useMutation(({ qrcodeID, state }: { qrcodeID: string; state: string }) => {
    const params = { qrcode_id: qrcodeID };
    return request.post('/user/confirm_qrcode', params);
  });
};

export const useQRCodeDelete = () => {
  return useMutation(({ qrcodeID }: { qrcodeID: string }) => {
    return request.post<{ is_success: boolean }>('/user/delete_qrcode', {
      qrcode_id: qrcodeID,
    });
  });
};
